// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import './ButtonComp.css';
const classes = [
  'big',
  'inverted',
  'small',
  'medium',
  'primary',
  'secondary',
  'light',
  'loading',
  'wide',
  'danger',
  'black',
  'double',
  'success'
];

const ButtonComp = (props: Object) => {
  let buttonClassName =
    (props.className || '') + ' kwh-button ' + classes.filter((name) => props[name]).join(' ');
  if (props.disabled) buttonClassName += ' disabled';
  let content = props.children;
  if (props.loading)
    content = (
      <ProgressBar type="circular" mode="indeterminate" multicolor className="button-loader" />
    );

  const btnProps = Object.keys(props).reduce((res, name) => {
    if (!~classes.indexOf(name)) res[name] = props[name];
    return res;
  }, {});
  delete btnProps.className;
  if (btnProps.to)
    return (
      <Link className={buttonClassName} {...btnProps}>
        {content}
      </Link>
    );
  if (btnProps.href)
    return (
      <a className={buttonClassName} {...btnProps}>
        {content}
      </a>
    );
  return (
    <button className={buttonClassName} {...btnProps}>
      {content}
    </button>
  );
};

export default ButtonComp;



// WEBPACK FOOTER //
// ./src/common/ButtonComp.js